import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { AppThunk } from '../store';

interface StateProps {
  selectedIrrigation: any
  irrigations: any[],
  selectedToggle: string | null,
  timeRange: number
}

const initialState: StateProps = {
  selectedIrrigation: null,
  irrigations: [],
  selectedToggle: 'chart',
  timeRange: 168
}

const slice = createSlice({
  name: "charts_store",
  initialState,
  reducers: {
    setSelectedIrrigation(state: StateProps, action: PayloadAction<any>): void { state.selectedIrrigation = action.payload },
    setIrrigations(state: StateProps, action: PayloadAction<any>): void { state.selectedIrrigation = action.payload },
    setSelectedToggle(state: StateProps, action: PayloadAction<string | null>): void { state.selectedToggle = action.payload },
    setTimeRange(state: StateProps, action: PayloadAction<number>): void { state.timeRange = action.payload }
  }
})

export const { reducer } = slice

export const setSelectedIrrigation = (value: any): AppThunk => (dispatch) => {
  dispatch(slice.actions.setSelectedIrrigation(value))
}

export const setSelectedToggle = (value: string | null): AppThunk => (dispatch) => {
  dispatch(slice.actions.setSelectedToggle(value))
}

export const setIrrigations = (value: any[]): AppThunk => (dispatch) => {
  dispatch(slice.actions.setIrrigations(value))
}

export const setTimeRange = (value: number): AppThunk => (dispatch) => {
  dispatch(slice.actions.setTimeRange(value))
}
